<template>
  <div>
    <via-nav-bar
      title="忘记密码"
      @click-left="$router.$back()"
    >
      <div
        slot="right"
        class="nav-right"
        @click="confirm"
      >确定</div>
    </via-nav-bar>
    <!-- 表单 -->
    <van-cell-group>
      <van-field
        v-model="form.email"
        required
        clearable
        :maxlength="30"
        label="邮箱"
        placeholder="填你注册时的邮箱"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { Field, Cell, CellGroup } from 'vant'
import { userValidate } from '~/utils/validate'

export default {
  name: 'ForgetPassword',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      form: {
        email: ''
      }
    }
  },
  methods: {
    confirm() {
      if (!this.validatedForm()) {
        return
      }
      const { email } = this.form
      this.$store.commit('globalData/updateLoading', true)
      this.$api.user.sendUpdatePasswordEmail({ email }).then(res => {
        this.$store.commit('globalData/updateLoading', false)
        // 保存发送成功时的时间
        window.localStorage.setItem('sendMailTime', new Date().getTime())
        this.$toast.success('邮件已发送，请检查你的邮箱')
      }).catch(() => this.$store.commit('globalData/updateLoading', false))
    },
    validatedForm() {
      const { email } = this.form
      const lastSendTime = window.localStorage.getItem('sendMailTime')
      const now = new Date().getTime()
      if (!email) {
        this.$toast.fail('邮箱不能为空')
        return false
      }
      if (userValidate('email', email)) {
        this.$toast.fail(userValidate('email', email))
        return false
      }
      if (lastSendTime) {
        const interval = parseInt((now - Number(lastSendTime)) / 1000)
        if (interval < 60) {
          this.$toast.fail(`请${60 - interval}秒后再尝试`)
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.nav-right {
  color: var(--themeColor)
}
</style>
